<script>
  import Icon from "./Icon.svelte";
</script>

<Icon>
  <title>Icon: shapes</title>
  <path
    d="M23,8 C23.5522847,8 24,8.44771525 24,9 L24,23 C24,23.5522847 23.5522847,24 23,24 L9,24 C8.44771525,24 8,23.5522847 8,23 L8,9 C8,8.44771525 8.44771525,8 9,8 L23,8 Z M22,10 L10,10 L10,22 L22,22 L22,10 Z"
  />
  <path
    d="M7.5,0 C11.6421356,0 15,3.35786438 15,7.5 C15,11.6421356 11.6421356,15 7.5,15 C3.35786438,15 0,11.6421356 0,7.5 C0,3.35786438 3.35786438,0 7.5,0 Z M7.5,2 C4.46243388,2 2,4.46243388 2,7.5 C2,10.5375661 4.46243388,13 7.5,13 C10.5375661,13 13,10.5375661 13,7.5 C13,4.46243388 10.5375661,2 7.5,2 Z"
  />
</Icon>
